// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._19itidpf{border:0}
._2rko1l7b{border-radius:3px}._154iidpf{top:0}
._18m915vq{overflow-y:hidden}
._1bsb1osq{width:100%}
._1ltvidpf{left:0}
._1reo15vq{overflow-x:hidden}
._4t3i1osq{height:100%}
._kqswh2mm{position:relative}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/node_modules/@atlaskit/smart-card/dist/esm/view/EmbedCard/components/Frame.compiled.css"],"names":[],"mappings":";AACA,WAAW,QAAQ;AACnB,WAAW,iBAAiB,CAAC,WAAW,KAAK;AAC7C,WAAW,iBAAiB;AAC5B,WAAW,UAAU;AACrB,WAAW,MAAM;AACjB,WAAW,iBAAiB;AAC5B,WAAW,WAAW;AACtB,WAAW,iBAAiB","sourcesContent":["\n._19itidpf{border:0}\n._2rko1l7b{border-radius:3px}._154iidpf{top:0}\n._18m915vq{overflow-y:hidden}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._1reo15vq{overflow-x:hidden}\n._4t3i1osq{height:100%}\n._kqswh2mm{position:relative}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
